import { useTranslation } from 'react-i18next';

import { ColorModel } from '~/core/models';
import ConfirmationDialog from '~molecules/ConfirmationDialog';

export interface ColorVizConfContentProps {
  isModalVisible: boolean;
  selectedColor?: ColorModel;
  onCancelChangingColorFromModal: () => void;
  onConfirmChangingColorFromModal: () => void;
  colorVizName: string;
}

const ColorVizConfContent = ({
  isModalVisible,
  selectedColor,
  onCancelChangingColorFromModal,
  onConfirmChangingColorFromModal,
  colorVizName,
}: ColorVizConfContentProps): JSX.Element | null => {
  const { t } = useTranslation();

  if (!isModalVisible) {
    return null;
  }

  return (
    <ConfirmationDialog
      visible={isModalVisible}
      onCancel={onCancelChangingColorFromModal}
      onConfirm={onConfirmChangingColorFromModal}
      title={t('SCROLLABLE_AREA.COLOR.COLOR_CHANGE_POP_UP_TITLE')}
      content={
        selectedColor
          ? t('SCROLLABLE_AREA.COLOR.COLOR_CHANGE_CONFIRMATION_PART1') +
            selectedColor.name +
            "' to '" +
            colorVizName +
            t('SCROLLABLE_AREA.COLOR.COLOR_CHANGE_CONFIRMATION_PART2')
          : ''
      }
    />
  );
};

export default ColorVizConfContent;
